/** Форматирование для интерфейса на текущем языке (i18n): суммы, пункты, время, этапы и действия. */
import { useEffect, useState } from 'react';
import type { GameStage, Minor } from '@mt/protocol';
import { credits, creditsBare, formatTime, num, t, type TKey } from '../i18n';
import { client } from '../net/client';

export const cr = (m: Minor) => credits(m);
/** Сумма без единицы — для таблиц, где единица указана в заголовке столбца. */
export const crn = (m: Minor) => creditsBare(m);

export function pts(x: number | null | undefined, signed = false): string {
  if (x === null || x === undefined) return '—';
  const s = num(Math.abs(x), 2);
  if (!signed) return (x < 0 ? '−' : '') + s;
  return (x > 0 ? '+' : x < 0 ? '−' : '±') + s;
}

export function secondsLeft(until: number | null, now: number): number | null {
  if (until === null) return null;
  return Math.max(0, Math.ceil((until - now) / 1000));
}

export const clock = (at: number) => formatTime(at);

/** Серверное «сейчас», перерисовка каждые 250 мс. */
export function useNow(intervalMs = 250): number {
  const [now, setNow] = useState(() => client.now());
  useEffect(() => {
    const id = setInterval(() => setNow(client.now()), intervalMs);
    return () => clearInterval(id);
  }, [intervalMs]);
  return now;
}

/** Словарь «по ключу» на текущем языке: STAGE_TITLES.round1 → t('common.stage.round1'). */
const lookup = <K extends string>(prefix: string) => new Proxy({} as Record<K, string>, { get: (_, k) => t(`${prefix}${String(k)}` as TKey) });

export const STAGE_TITLES = lookup<GameStage>('common.stage.');
export const ACTION_TITLES = lookup<string>('common.action.');
